// import React, { useState } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import samplePDF from '../Images/CHINEDU JOSEPH NDU COVER LETTER 2023.pdf';
// import '../CSS/CoverLetter.css';

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const CoverLetter = () => {
//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1);

//   // Called when the document loads successfully
//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//     setPageNumber(1); // Reset to the first page on load
//   };

//   // Functions to handle page navigation
//   const goToNextPage = () => setPageNumber((prevPage) => Math.min(prevPage + 1, numPages));
//   const goToPreviousPage = () => setPageNumber((prevPage) => Math.max(prevPage - 1, 1));

//   return (
//     <div className='coverletterwrap'>
//       <h2>MY COVER LETTER</h2>
//       <Document file={samplePDF} onLoadSuccess={onDocumentLoadSuccess} className="Doc">
//         <Page pageNumber={pageNumber} />
//       </Document>
//       <div>
//         <p>
//           Page {pageNumber} of {numPages}
//         </p>
//         <button disabled={pageNumber <= 1} onClick={() => { goToPreviousPage(); window.scroll(0, 0); }}>
//           Previous
//         </button>
      
//         <button disabled={pageNumber >= numPages} onClick={() => { goToNextPage(); window.scroll(0, 0); }}>
//           Next
//         </button>
//       </div>
      
//       {/* Download button */}
//       <a href={samplePDF} download="CHINEDU_JOSEPH_NDU_COVER_LETTER_2023.pdf">
//         <button>
//           Download Cover Letter
//         </button>
//       </a>
//     </div>
//   );
// };

// export default CoverLetter;



import React, { useContext, useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Context } from "./Context";
import "../CSS/CoverLetter.css";
import { useParams } from "react-router-dom";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = () => {



const pastProjects= [
     // Files in the order they appear in the image
     {id:1, title: "4 LANE BRIDGE MODEL AND COORDINATION", file: require("../PROJECTS/4LANE_BRIDGE MODEL AND COORDINATION.pdf") },
     {id:2, title: "6 HECTARE PLANT DEVELOPMENT", file: require("../PROJECTS/6HECTARE PLANT DEVELOPMENT_CIVIL_STRUCTURAL DRAWINGS.pdf") },
     {id:3, title: "AHU PLATFORM", file: require("../PROJECTS/AHU PLATFORM.pdf") },
     {id:4, title: "CONCRETE WORK EXTENSION", file: require("../PROJECTS/CONCRETE WORK EXTENSION_WAREHOUSE.pdf") },
     {id:5, title: "FLOOD CONTROL", file: require("../PROJECTS/FLOOD CONTROL .pdf") },
     {id:6, title: "INFRASTRUCTURAL DEVELOPMENT PROJECT", file: require("../PROJECTS/Infrastructural Development Project_Melegun Town.pdf") },
     // Skipping ID 7 and 8 to match the original structure's commented items
     {id:9, title: "RESIDENTIAL DEVELOPMENT", file: require("../PROJECTS/RESIDENTIAL DEVELOPMENT.pdf") },
     {id:10, title: "SCAN TO BIM SAMPLE PROJECT", file: require("../PROJECTS/SCAN TO BIM SAMPLE PROJECT.pdf") },
     {id:11, title: "STRUCTURAL OBSERVATION OF HIGH RISE BUILDING", file: require("../PROJECTS/Structural Observation Of High Rise Building.pdf") },
     {id:12, title: "STRUCTURAL PIPE BRIDGE", file: require("../PROJECTS/STRUCTURAL PIPE BRIDGE.pdf") },
     {id:13, title: "STRUCTURAL WAREHOUSE", file: require("../PROJECTS/STRUCTURAL WAREHOUSE.pdf") },

    // The two original, non-project file items are kept but remain commented out.
{id:7,
title: "COVER LETTER",
file: require("../Images/CHINEDU JOSEPH NDU COVER LETTER 2023.pdf"),
},
{id:8,
 title: "CREDENTIALS",
file: require("../Images/Credentials_Chinedu Joseph Ndu .pdf"),
},

{
    id:14,
    title: "MY CV",
    file: require("../Images/CHINEDU JOSEPH NDU CV - 2025_ REC.pdf")
}
]

const {id} = useParams();


const [selectedPdf, setSelectedPdf]=useState(null);


 useEffect(() => {
    // Convert id to number because route params are strings
    const projectId = parseInt(id, 10);

    // Find the matching PDF
    const pdf = pastProjects.find((p) => p.id === projectId);

    if (pdf) {
      setSelectedPdf(pdf);
    }
  }, [id]);

  // const { selectedPdf } = useContext(Context);



  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // Reset page when new PDF is loaded
  useEffect(() => {
    setPageNumber(1);
  }, [selectedPdf]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  const goToPreviousPage = () =>
    setPageNumber((prev) => Math.max(prev - 1, 1));

  if (!selectedPdf) {
    return (
      <div className="coverletterwrap">
        <h2>Select a PDF to view</h2>
      </div>
    );
  }

  return (
    <div className="coverletterwrap">
      <h2>{selectedPdf.title}</h2>

      <Document
        file={selectedPdf.file}
        onLoadSuccess={onDocumentLoadSuccess}
        className="Doc"
      >
        <Page pageNumber={pageNumber} />
      </Document>

      <div>
        <p>
          Page {pageNumber} of {numPages}
        </p>

        <button
          disabled={pageNumber <= 1}
          onClick={() => {
            goToPreviousPage();
            window.scroll(0, 0);
          }}
        >
          Previous
        </button>

        <button
          disabled={pageNumber >= numPages}
          onClick={() => {
            goToNextPage();
            // window.scroll(0, 0);
          }}
        >
          Next
        </button>
      </div>

      <a href={selectedPdf.file} download={selectedPdf.title + ".pdf"}>
        <button>Download {selectedPdf.title}</button>
      </a>

      {/* <p style={{fontFamily:"Arial", cursor:"pointer", color:"blue"}} onClick={()=>window.history.back()}>Back</p> */}
    </div>
  );
};

export default PDFViewer;
